<template>
  <div style="height: 100%; width: 100%">
    <q-table
      :style="cssVars"
      :data="data"
      :columns="columns"
      :separator="separator"
      :rows-per-page-options="[0]"
      :pagination.sync="syncPagination"
      :flat="flat"
      :grid="grid"
      :filter="filter"
      :filter-method="customFilter"
      virtual-scroll
      row-key="id"
      @row-click="handleClick"
      @row-dblclick="handleDoubleClick"
      :selected.sync="selected"
      :class="{
        sticky: sticky,
      }"
    >
      <template
        v-for="column in columns"
        v-slot:[`header-cell-${column.name}`]="props"
      >
        <slot :name="`header-cell-${column.name}`" v-bind:props="props">
          <q-th :props="props">
            <span
              :class="{
                columnLabel: !column.boldHeader,
                columnLabelBold: column.boldHeader,
                columnCaps: column.capsHeader,
              }"
            >
              {{ column.label }}
            </span>
          </q-th>
        </slot>
      </template>
      <template
        v-for="column in columns"
        v-slot:[`body-cell-${column.name}`]="props"
      >
        <slot :name="`body-cell-${column.name}`" v-bind:props="props">
          <q-td :props="props">
            <span
              :class="{
                rowLabelBold: column.boldItems,
                rowLabel: !column.boldItems,
              }"
            >
              {{ props.value }}
            </span>
          </q-td>
        </slot>
      </template>
    </q-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters([]),
    cssVars() {
      return {
        "--header-bg-color": this.headerBgColor,
        "--header-text-color": this.headerTextColor,
        width: "100%",
      };
    },
  },
  props: {
    columns: Array,
    data: Array,
    flat: {
      type: Boolean,
      default: false,
    },
    headerBgColor: {
      type: String,
      default: "white",
    },
    headerTextColor: {
      type: String,
      default: "black",
    },
    separator: {
      type: String,
      default: "horizontal",
    },
    sticky: {
      type: Boolean,
      default: true,
    },
    grid: {
      type: Boolean,
      default: false,
    },
    filter: {
      default: "",
    },
    externalFilter: {
      type: Function,
    },
    pagination: {
      default: null,
    },
  },
  watch: {},
  data: () => ({
    syncPagination: {
      rowsPerPage: 0,
    },
    selected: [],
  }),
  mounted() {
    this.syncPagination = this.pagination
      ? JSON.parse(JSON.stringify(this.pagination))
      : this.syncPagination;
  },
  methods: {
    handleClick(evt, row, index) {
      this.selected = [row];
      this.$emit("rowSelected", row);
    },
    handleDoubleClick(evt, row, index) {
      this.$emit("rowDoubleClick", row);
    },
    customFilter(rows, terms, cols) {
      // If terms is a straight string then search as normal Otherwise use externalFilter()
      if (typeof terms == "string") {
        return rows.filter((row) => {
          let matchFound = false;
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            matchFound = val.toLowerCase().indexOf(terms.toLowerCase()) > -1;

            if (matchFound == true) {
              i = cols.length;
            }
          }
          return matchFound;
        });
      } else {
        // External Filter is sent through as a Property
        return this.externalFilter(rows, terms, cols);
      }
    },
  },
};
</script>

<style lang="scss">
.sticky {
  height: 100% !important;

  .q-table__bottom,
  thead tr:first-child th {
    /* bg color is important for th; just specify one */
    background-color: white;
    color: black;
  }

  .q-table__top,
  thead tr:first-child th {
    /* bg color is important for th; just specify one */
    background-color: var(--header-bg-color);
    color: var(--header-text-color);
  }

  thead tr th {
    position: sticky;
    z-index: 1;
  }

  thead tr:first-child th {
    top: 0;
  }

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th {
    top: 48px;
    /* height of all previous header rows */
  }
}

.columnLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
}

.columnLabelBold {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
}

.columnCaps {
  text-transform: uppercase;
}

.rowLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: black;
}

.rowLabelBold {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 13px;
  display: flex;
  align-items: center;
  color: #162c47;
}
</style>
